import { render, staticRenderFns } from "./df-pk10.vue?vue&type=template&id=60bc4dd4"
import script from "./df-pk10.vue?vue&type=script&lang=js"
export * from "./df-pk10.vue?vue&type=script&lang=js"
import style0 from "./df-pk10.vue?vue&type=style&index=0&id=60bc4dd4&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports